export default __webpack_public_path__ + "static/media/QuoteMarks.281b0ef3.svg";